import { c as _c } from "react/compiler-runtime";
import React from "react";
import { UseFormRegister, UseFormSetValue, FieldError } from "react-hook-form";
import { LocationSuggestion } from "@/types/location";
import styles from "@/features/partner-with-us/BusinessDetailsForm/main.module.css";
interface LocationInputProps {
  inputValue: string;
  suggestions: LocationSuggestion[];
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputFocus?: () => void;
  handleInputBlur?: () => void;
  handleSelectSuggestion: (suggestion: LocationSuggestion, setValue: (field: string, value: string) => void) => void;
  error?: FieldError | {
    type: string;
    message: string;
  };
  isLoading?: boolean;
  isLoadingSuggestions?: boolean;
  suggestionsError?: Error | null;
  validateLocation?: (value: string) => string | true;
  isLocationSelected?: boolean;
  hasShownSuggestions?: boolean;
  isFocused?: boolean;
}
const LocationInput: React.FC<LocationInputProps> = t0 => {
  const $ = _c(28);
  const {
    inputValue,
    suggestions,
    setValue,
    handleInputChange,
    handleInputFocus,
    handleInputBlur,
    handleSelectSuggestion,
    error,
    isLoading,
    isLoadingSuggestions,
    suggestionsError
  } = t0;
  let t1;
  if ($[0] !== handleSelectSuggestion || $[1] !== setValue) {
    t1 = (e, suggestion) => {
      e.preventDefault();
      e.stopPropagation();
      handleSelectSuggestion(suggestion, setValue);
    };
    $[0] = handleSelectSuggestion;
    $[1] = setValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSuggestionClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label className={styles.label}>Location</label>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleInputBlur || $[5] !== handleInputChange || $[6] !== handleInputFocus || $[7] !== inputValue || $[8] !== isLoading) {
    t3 = <input type="text" value={inputValue} onChange={handleInputChange} onFocus={handleInputFocus} onBlur={handleInputBlur} placeholder="Enter location here" disabled={isLoading} className={styles.input} />;
    $[4] = handleInputBlur;
    $[5] = handleInputChange;
    $[6] = handleInputFocus;
    $[7] = inputValue;
    $[8] = isLoading;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== error) {
    t4 = error && <p className={styles.errorMessage}>{error.message}</p>;
    $[10] = error;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== suggestionsError) {
    t5 = suggestionsError && <p className={styles.errorMessage}>Error loading suggestions. Please try again.</p>;
    $[12] = suggestionsError;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== inputValue || $[15] !== isLoadingSuggestions) {
    t6 = isLoadingSuggestions && inputValue.length >= 3 && <div className={styles.suggestionsContainer}><div className={styles.suggestionsList}><div className={styles.suggestionItem}><div className={styles.suggestionContent}><span className={styles.loadingText}>Loading suggestions...</span></div></div></div></div>;
    $[14] = inputValue;
    $[15] = isLoadingSuggestions;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== handleSuggestionClick || $[18] !== isLoading || $[19] !== isLoadingSuggestions || $[20] !== suggestions) {
    t7 = suggestions.length > 0 && !isLoading && !isLoadingSuggestions && <div className={styles.suggestionsContainer}><div className={styles.suggestionsList}>{suggestions.map((suggestion_0, index) => <div key={index} className={styles.suggestionItem} onClick={e_0 => handleSuggestionClick(e_0, suggestion_0)} onMouseDown={_temp}><div className={styles.suggestionContent}><svg className={styles.locationIcon} viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg><span className={styles.suggestionText}>{suggestion_0.description}</span></div></div>)}</div></div>;
    $[17] = handleSuggestionClick;
    $[18] = isLoading;
    $[19] = isLoadingSuggestions;
    $[20] = suggestions;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={styles.locationContainer}>{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
export default LocationInput;
function _temp(e_1) {
  return e_1.preventDefault();
}